import * as React from "react";

import { cn } from "./utils";

interface ModalOverlayProps extends React.ComponentProps<"div"> {
  /** Where the modal panel sits within the viewport. */
  align?: "center" | "top" | "end";
}

const alignmentClasses: Record<NonNullable<ModalOverlayProps["align"]>, string> = {
  center: "items-center justify-center",
  top: "items-start justify-center pt-[15vh]",
  end: "items-end justify-end",
};

/**
 * Shared backdrop scrim for modals/drawers — the one place blur is allowed
 * (see guidelines/Guidelines.md). Consumers keep their own dialog markup,
 * close handlers, and focus management; this just centralizes the backdrop
 * so every modal in the app looks and behaves identically.
 */
function ModalOverlay({ align = "center", className, children, ...props }: ModalOverlayProps) {
  return (
    <div
      data-slot="modal-overlay"
      className={cn(
        "fixed inset-0 z-50 flex p-4 bg-black/50 backdrop-blur-sm",
        alignmentClasses[align],
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export { ModalOverlay };
